module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6b0a20bccc411ed053bd1df1ee10c154.png";